import React, { useContext } from 'react';

import ScorecardContext from 'contexts/ScorecardContext';
import useScorecardQuickFilterCompatibility from 'screens/ScorecardShow/useScorecardQuickFilterCompatibility';
import Row from 'components/Common/Row';

import { QuickFilter } from '../../CustomerLaneCommitsBoard/QuickFilters/QuickFilters';

const ScorecardQuickFiltersDisplay = () => {
  const {
    scorecard,
    quickFilters,
    selectedQuickFilters,
    setSelectedQuickFilters,
  } = useContext(ScorecardContext);
  const getCompatibility = useScorecardQuickFilterCompatibility({ scorecard });
  const quickFilterOrder = scorecard.quickFilterOrder || [];

  const onFilterToggled = (filter: LegacySavedFilter) => {
    const isSelected = selectedQuickFilters.some((f) => f.id === filter.id);
    if (isSelected) {
      setSelectedQuickFilters((fs) => fs.filter((f) => f.id !== filter.id));
    } else {
      setSelectedQuickFilters((fs) => [...fs, filter]);
    }
  };

  // quickFilterOrder may reference IDs for filters that have since been deleted.
  // Filter those out, then append any filters missing from the order array at the end.
  const orderedFilters = quickFilterOrder
    .map((filterId) => quickFilters.find((f) => f.id === filterId))
    .filter((f): f is LegacySavedFilter => !!f);
  const filtersNotInOrder = quickFilters.filter(
    (f) => !quickFilterOrder.includes(f.id),
  );
  orderedFilters.push(...filtersNotInOrder);

  if (orderedFilters.length === 0) {
    return null;
  }

  return (
    <Row
      centerAlign
      style={{ gap: 8, flexWrap: 'wrap', padding: '8px 24px 0' }}
    >
      {orderedFilters.map((f) => {
        const compatibility = getCompatibility(f);
        return (
          <QuickFilter
            key={f.id}
            onClick={() => onFilterToggled(f)}
            isSelected={selectedQuickFilters.some((sf) => sf.id === f.id)}
            name={f.name || 'Filter'}
            isDisabled={!compatibility.isCompatible}
            isDisabledMessage={compatibility.reason}
          />
        );
      })}
    </Row>
  );
};

export default ScorecardQuickFiltersDisplay;
